import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
// import EfisModalJustificativa from "../../../../components/UI/EfisModal/EfisModalJustificativa";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import EfisModalJustificativaCancel from "../../../../components/UI/EfisModal/EfisModalJustificativaCancel";

const useCancelarOs = ({ formik }) => {
  const [showCancelarConfirm, setShowCancelarConfirm] = useState({
    title: null,
    body: null,
    show: false,
  });

  const {
    request: requestCancela,
    data: dataCancela,
    errors: errorsCancela,
    isLoading: isLoadingCancela,
  } = useApiClient();

  const { setErrors } = formik;

  useEffect(() => {
    if (!dataCancela && !errorsCancela) return;

    if (dataCancela) {
      toast.success("Cancelamento realiazado com sucesso.");
    }

    if (errorsCancela) {
      setErrors((curr) => ({ ...curr, ...errorsCancela }));
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    setShowCancelarConfirm({ show: false });
  }, [setShowCancelarConfirm, dataCancela, errorsCancela, setErrors]);

  const cancelaDocumentoOs = useCallback(
    (codigo, situacao, texto) => {
      requestCancela(apiRoutes.fiscalizacao.ordemservico.cancelaDocumentoOs, {
        numero: codigo,
        situacaoOrdemServico: situacao,
        textoJustificativa: texto,
      });
    },
    [requestCancela],
  );

  const { request: requestVerificaOs, data: dataVerificaOs, requestExtra: verificacaoCodigoOs } = useApiClient();

  useEffect(() => {
    if (dataVerificaOs) {
      const mensagem = dataVerificaOs.result;
      if (mensagem === "" || mensagem == null) {
        setShowCancelarConfirm({
          title: "Justificativa para cancelamento",
          body: `Cancelar OS Nº ${verificacaoCodigoOs}`,
          show: true,
          codigo: verificacaoCodigoOs,
          situacao: "N",
          justificar: true,
        });
      } else {
        setShowCancelarConfirm({
          title: "Atenção!",
          body: `${mensagem}`,
          show: true,
          justificar: false,
        });
      }
    }
  }, [dataVerificaOs, verificacaoCodigoOs, setShowCancelarConfirm]);

  const verificaOs = useCallback(
    (codigo) => {
      requestVerificaOs(
        apiRoutes.fiscalizacao.ordemservico.verificaOrdemServico,
        { sqOrdemServico: codigo },
        { requestExtra: codigo },
      );
    },
    [requestVerificaOs],
  );

  const cancelarOsModal = (
    <>
      <FormAlert formik={formik} data={dataCancela} errors={errorsCancela} isLoading={isLoadingCancela} dismissible />
      <EfisModalJustificativaCancel
        show={showCancelarConfirm.show}
        title={showCancelarConfirm.title}
        loadingConfirmationAction={isLoadingCancela}
        codigo={showCancelarConfirm.codigo}
        situacao={showCancelarConfirm.situacao}
        justificar={showCancelarConfirm.justificar}
        closeHandler={() => setShowCancelarConfirm({ show: false })}
        confirmationHandler={(codigo, situacao, texto) => {
          cancelaDocumentoOs(codigo, situacao, texto);
        }}
        body={showCancelarConfirm.body}
      />
    </>
  );

  return {
    cancelarOsModal,
    setShowCancelarConfirm,
    verificaOs,
  };
};

export default useCancelarOs;
